<template>
  <div
    class="culturalMore"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <Pic-top></Pic-top>
    <div class="culturalMoreTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">Home</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="culture" class="color"
            >Cultural and creative products</router-link
          >
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="culturalMoreContont">
      <div class="section">
        <!-- PC -->
        <div class="goodsList hidden-xs-only">
          <water-fall-culture
             :data="goodsList"
             v-if="goodsList.length !== 0"
          ></water-fall-culture>
          <div class="noMessage" v-if="goodsList.length == 0 && !loading">none</div>
        </div>
        <div class="middle_bottom">
          <img src="../../assets/cultural/Cultural_two_bottom.gif" alt="" />
          <div class="title eng_title">
            <div class="button eng_button" @click="goCulturalCustomMade()">
              AI assisted cultural and creative customization
            </div>
          </div>
        </div>
        <!-- 手机 -->
        <div class="goodsList hidden-sm-and-up">
          <water-fall-mobile-culture
            :data="mobileGoodsList"
            v-if="mobileGoodsList.length !== 0"
          ></water-fall-mobile-culture>
          <div class="noMessage" v-if="mobileGoodsList.length == 0 && !loading">none</div>
        </div>
        <div
          class="loading"
          v-loading="loading"
          element-loading-text="Loading"
          element-loading-spinner="el-icon-loading"
        ></div>
      </div>
    </div>
    <el-popover placement="left" width="250" trigger="hover">
      <div class="tel">Qinghai Zhumuyaru Digital Technology Co., Ltd.</div>
      <div class="tel">Mr Tao: 18308018896</div>
      <div class="tel">E-mail: huanshu@yarlung.cn</div>
      <div class="contact" slot="reference">
        <div class="message">
          <img src="../../assets/cultural/user.png" alt="" />
          <div class="hidden-xs-only" style="font-size: 14px">Cultural and Creative Consulting</div>
          <div class="hidden-sm-and-up" style="font-size: 0.12rem">Cultural and Creative Consulting</div>
        </div>
      </div>
    </el-popover>
    <!-- <el-popover placement="left" width="250" trigger="hover">
      <div class="tel">Contact Number：{{templeContact}}</div>
      <div class="tel">Email：regong_art_db@163.com</div>
      <div class="contact" slot="reference">
        <div class="message eng_message">
          <img src="../../assets/cultural/user.png" alt="" />
          <div class="hidden-xs-only">Cultural and Creative Consulting</div>
          <div class="hidden-sm-and-up">Cultural and Creative Consulting</div>
        </div>
      </div>
    </el-popover> -->
  </div>
  <div class="culturalMore" v-else-if="this.language == 'en'">
    <Pic-top></Pic-top>
    <div class="culturalMoreTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">ངོ་བྱང་།</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="culture" class="color"
            >རིག་གཏོད་ཐོན་རྫས།</router-link
          >
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="culturalMoreContont">
      <div class="section">
        <!-- PC -->
        <div class="goodsList hidden-xs-only">
          <water-fall-culture
             :data="goodsList"
             v-if="goodsList.length !== 0"
          ></water-fall-culture>
          <div class="noMessage" v-if="goodsList.length == 0 && !loading">གནས་སྐབས་གཞི་གྲངས་མེད་པ་</div>
        </div>
        <div class="middle_bottom">
          <img src="../../assets/cultural/Cultural_two_bottom.gif" alt="" />
          <div class="title eng_title">
            <div class="button eng_button" @click="goCulturalCustomMade()">
              AIརམ་འདེགས་རིག་གཏོད་ཁྱད་བཟོ།
            </div>
          </div>
        </div>
        <!-- 手机 -->
        <div class="goodsList hidden-sm-and-up">
          <water-fall-mobile-culture
            :data="mobileGoodsList"
            v-if="mobileGoodsList.length !== 0"
          ></water-fall-mobile-culture>
          <div class="noMessage" v-if="mobileGoodsList.length == 0 && !loading">གནས་སྐབས་གཞི་གྲངས་མེད་པ་</div>
        </div>
        <div
          class="loading"
          v-loading="loading"
          element-loading-text="གཞི་གྲངས་སྣོན་འཇུག་ཁྲོད་"
          element-loading-spinner="el-icon-loading"
        ></div>
      </div>
    </div>
    <el-popover placement="left" width="240" trigger="hover">
      <div class="tel">མཚོ་སྔོན་ཇོ་མ་ཡར་ཀླུང་གྲངས་འཛིན་ཚན་རྩལ་ཚད་ཡོད་ཀུང་སི།</div>
      <div class="tel">དགེ་རྒན་ཐོའོ། 18308018896</div>
      <div class="tel">ཡིག་ཟམ། huanshu@yarlung.cn</div>
      <div class="contact" slot="reference">
        <div class="message">
          <img src="../../assets/cultural/user.png" alt="" />
          <div class="hidden-xs-only">རིག་གཏོད་འདྲི་རྩད།</div>
          <div class="hidden-sm-and-up">རིག་གཏོད་འདྲི་རྩད།</div>
        </div>
      </div>
    </el-popover>
    <!-- <el-popover placement="left" width="240" trigger="hover">
      <div class="tel">འབྲེལ་གཏུགས་ཨང་གྲངས།：{{templeContact}}</div>
      <div class="tel">སྦྲགས་ཡིག：regong_art_db@163.com</div>
      <div class="contact" slot="reference">
        <div class="message za_message">
          <img src="../../assets/cultural/user.png" alt="" />
          <div class="hidden-xs-only">རིག་གཏོད་འདྲི་རྩད།</div>
          <div class="hidden-sm-and-up">རིག་གཏོད་འདྲི་རྩད།</div>
        </div>
      </div>
    </el-popover> -->
  </div>
  <div class="culturalMore" v-else>
    <Pic-top></Pic-top>
    <div class="culturalMoreTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">首页</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="culture" class="color">文创产品</router-link>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="culturalMoreContont">
      <div class="section">
        <!-- PC -->
        <div class="goodsList hidden-xs-only">
          <water-fall-culture
             :data="goodsList"
             v-if="goodsList.length !== 0"
          ></water-fall-culture>
          <div class="noMessage" v-if="goodsList.length == 0 && !loading">暂无数据</div>
        </div>
        <div class="middle_bottom">
          <img src="@/assets/cultural/Cultural_two_bottom.gif" alt="" />
          <!-- src="@/assets/cultural/Cultural_two_bottom.gif" -->
          <div class="title">
            <div class="button" @click="goCulturalCustomMade()">
              AI辅助文创定制
            </div>
          </div>
        </div>
        <!-- 手机 -->
        <div class="goodsList hidden-sm-and-up">
          <water-fall-mobile-culture
            :data="mobileGoodsList"
            v-if="mobileGoodsList.length !== 0"
          ></water-fall-mobile-culture>
          <div class="noMessage" v-if="mobileGoodsList.length == 0 && !loading">暂无数据</div>
        </div>
        <div
          class="loading"
          v-loading="loading"
          element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
        ></div>
      </div>
    </div>
    <el-popover placement="left" width="240" trigger="hover">
      <div class="tel">青海珠穆雅鲁数字科技有限公司</div>
      <div class="tel">陶老师：18308018896</div>
      <div class="tel">邮箱：huanshu@yarlung.cn</div>
      <div class="contact" slot="reference">
        <div class="message">
          <img src="../../assets/cultural/user.png" alt="" />
          <div class="hidden-xs-only">文创咨询</div>
          <div class="hidden-sm-and-up">文创咨询</div>
        </div>
      </div>
    </el-popover>
    <!-- <el-popover placement="left" width="240" trigger="hover">
      <div class="tel">联系电话：{{templeContact}}</div>
      <div class="tel">邮件：regong_art_db@163.com</div>
      <div class="contact" slot="reference">
        <div class="message">
          <img src="../../assets/cultural/user.png" alt="" />
          <div class="hidden-xs-only">文创咨询</div>
          <div class="hidden-sm-and-up">文创咨询</div>
        </div>
      </div>
    </el-popover> -->
  </div>
</template>
<script>
import PicTop from "../../components/picsTop.vue";
import { goodsPage } from "../../api/management";
import waterFallCulture from "../../components/waterFallCulture.vue";
import waterFallMobileCulture from "../../components/waterFallMobileCulture.vue";
import { throttle } from 'lodash'
export default {
  components: {
    PicTop,
    waterFallCulture,
    waterFallMobileCulture
  },
  data() {
    return {
      url: process.env.VUE_APP_WEB_URL,
      language: this.$store.state.language,
      total: null,
      goodsList: [],
      queryInfo: {
        current: 1,
        pageSize: 9,
      },
      //手机
      mobileTotal: null,
      mobileGoodsList: [],
      Info: {
        current: 1,
        pageSize: 8,
      },
      loading: false,
      isLoading:false,
      templeContact:'18997193666'
    };
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  methods: {
    goCulturalCustomMade() {
      this.$router.push("/culturalCustomMade");
    },
    async getGoodsPage() {
      this.loading = true
      const res = await goodsPage(this.queryInfo);
      if (res.code == 1) {
        this.loading = false
        this.isLoading = false
        this.goodsList = this.goodsList.concat(res.data.records);
        this.total = res.data.total;
      }
    },
    getPCorMobile() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.getMobileGoodsPage();
        window.addEventListener("scroll", this.Scrollbottom, true);
      } else {
        this.getGoodsPage();
        window.addEventListener("scroll", this.PCscrollBottom, true);
      }
    },
    async getMobileGoodsPage() {
      this.loading = true
      const res = await goodsPage(this.Info);
      if (res.code == 1) {
        this.loading = false
        this.isLoading = false
        this.mobileGoodsList = this.mobileGoodsList.concat(res.data.records);
        this.mobileTotal = res.data.total;
      }
    },
    PCscrollBottom:throttle(function(event) {
      // 变量scrollTop为当前页面的滚动条纵坐标位置
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 变量 windowHeight 是可视区的高度
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 变量 scrollHeight 是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // 到底的条件
      if (scrollTop + windowHeight == scrollHeight) {
        if(this.isLoading) {
          if (this.queryInfo.current * 9 >= this.total) {
            this.isLoading = false
            return this.$message("数据加载完毕");
          }
          this.loading = true;
          this.queryInfo.current++;
          this.getGoodsPage();
        }
        // if (this.queryInfo.current * 9 >= this.total)
        //   return this.$message("数据加载完毕");
        // this.loading = true;
        // setTimeout(() => {
        //   this.queryInfo.current++;
        //   this.getGoodsPage();
        // }, 1000);
      } else {
        this.isLoading = true
      }
    },1000),
    Scrollbottom:throttle(function(event) {
      // 变量scrollTop为当前页面的滚动条纵坐标位置
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 变量 windowHeight 是可视区的高度
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 变量 scrollHeight 是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // 到底的条件
      if (scrollTop + windowHeight + 100 >= scrollHeight) {
        if(this.isLoading) {
          if (this.Info.current * 8 >= this.mobileTotal) {
            this.isLoading = false
            return this.$message("数据加载完毕");
          }
          this.loading = true;
          this.Info.current++;
          this.getMobileGoodsPage();
        }
      } else {
        this.isLoading = true
      }
    },2000),
    //详情
    goDetail(id) {
      this.$router.push({ path: "/culturalGoodsDetail", query: { id: id } });
    },
    mobileGoDetail(id) {
      this.$router.push({ path: "/culturalGoodsDetail", query: { id: id } });
    },
    handleRouter(num) {
      this.$store.commit("changeNum", num);
      this.$router.push("/index");
    },
  },
  mounted() {
    document.documentElement.scrollTop = 0;
    new this.$wow.WOW().init();
    this.getPCorMobile();
  },
  created() {},
  beforeDestroy() {
    window.removeEventListener("scroll", this.PCscrollBottom, true);
    window.removeEventListener("scroll", this.Scrollbottom, true);
  },
};
</script>
<style lang="scss">
.culturalMore {
  background: url("../../assets/newImage/index/could_right.png") no-repeat right
    bottom;
  background-position: 100% 100%;
  position: relative;
  background-size: 7%;
  .culturalMoreTop {
    position: relative;
    border-bottom: 1px solid #f4f5f6;
    .section {
      padding: 50px 0;
      font-size: 18px;
      position: relative;
      .section_left {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        z-index: 88;
        .color {
          color: #ed201a;
        }
        span {
          cursor: pointer;
        }
      }
    }
    .cloudLeft {
      position: absolute;
      top: 50px;
      left: 0;
      z-index: 1;
      width: 125px;
      height: 95px;
    }
  }
  .culturalMoreContont {
    margin: 30px 0;
    position: relative;
    .section {
      .goodsList {
        padding: 30px 0;
        .noMessage{
          display: flex;
          justify-content: center;
          letter-spacing: 4px;
          font-weight: bold;
          font-size: 24px;
          text-align: center;
        }
      }
      .middle_bottom {
        margin: 20px 0 20px 0;
        position: relative;
        img {
          width: 1200px;
        }
        .title {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          .button {
            font-size: 30px;
            font-family: "fangzang";
            padding: 10px 20px;
            background-color: #971118;
            color: #fff;
            border-radius: 6px;
            cursor: pointer;
          }
          .eng_button {
            font-family: "Times New Roman", Times, serif;
            padding: 10px 16px;
          }
        }
      }
      .loading {
        height: 30px;
        .el-loading-mask {
          .el-loading-spinner {
            .el-icon-loading {
              color: #ef3731;
            }
            .el-loading-text {
              color: #ef3731;
            }
          }
        }
      }
    }
  }
  .contact {
    z-index: 999;
    color: #fff;
    position: fixed;
    right: 2%;
    bottom: 30%;
    .message {
      padding: 0 10px;
      display: flex;
      text-align: center;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 110px;
      height: 110px;
      border-radius: 100%;
      background-color: #99131a;
      margin-bottom: 20px;
      box-shadow: 0 0 10px #99131a;
      img {
        width: 32px;
        margin-bottom: 6px;
      }
    }
  }
}
@media (max-width: 768px) {
  .culturalMore {
    width: 100%;
    background: url("../../assets/newImage/index/could_right.png") no-repeat
      right bottom;
    background-size: 1rem;
    position: relative;
    padding-bottom: 0.3rem;
    .culturalMoreTop {
      .section {
        background: url("../../assets/newImage/index/could_left.png") no-repeat
          top left;
        background-position: 0 50%;
        background-size: 15%;
        padding: 0.6rem 0.2rem;
        font-size: 0.3rem;
        .section_left {
          left: 0.2rem;
        }
      }
    }
    .culturalMoreContont {
      margin: 0.1rem;
      .section {
        .goodsList {
          padding: .2rem 0;
          .noMessage{
            display: flex;
            justify-content: center;
            font-size: .4rem;
          }
        }
        .middle_bottom{
          width: 100%;
          margin: .5rem 0;
          img {
            width: 100%;
          }
          .title {
            .button{
              font-size: .3rem;
            }
            .eng_button{
              font-size: .2rem;
            }
          }
        }
      }
    }
    .contact {
      bottom: 35%;
      .message {
        text-align: center;
        width: 1.2rem;
        height: 1.2rem;
        margin-bottom: 0.2rem;
        display: flex;
        justify-self: center;
        align-items: center;
        flex-direction: column;
        img {
          width: 0.4rem;
        }
        div {
          font-size: 0.2rem;
        }
      }
      .za_message {
        width: 1.68rem;
        height: 1.68rem;
        div {
          font-size: 0.1rem;
        }
      }
      .eng_message {
        width: 1.8rem;
        height: 1.8rem;
      }
    }
  }
}
</style>
